module.exports = __webpack_public_path__ + "static/img/ccf_logo.851e44e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ccf_logo.jpg
// module id = pFXs
// module chunks = 11